export default __webpack_public_path__ + "static/media/Other.383df34e.svg";